import { render, staticRenderFns } from "./ExteriorCarColorCarousel.vue?vue&type=template&id=2313209d&scoped=true&"
import script from "./ExteriorCarColorCarousel.vue?vue&type=script&lang=js&"
export * from "./ExteriorCarColorCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313209d",
  null
  
)

export default component.exports